module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_26.bb7e93db.jpg";